// 時刻を生成するヘルパー関数（UTCとして扱い、JST変換を避ける）
export const generateTimeLabel = (startTime: Date, intervalMinutes: number, index: number): string => {
  const time = new Date(startTime.getTime() + (index * intervalMinutes * 60 * 1000));
  const hours = time.getUTCHours().toString().padStart(2, '0');
  const minutes = time.getUTCMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

// Y軸の範囲を動的に計算するヘルパー関数
export const calculateYAxisDomain = (values: number[], marginPercent: number = 10): [number, number] => {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min;
  const margin = range * (marginPercent / 100);
  
  return [
    Math.max(0, min - margin),
    max + margin
  ];
};

// 温度専用のY軸範囲計算（固定マージン）
export const calculateTemperatureYAxisDomain = (values: number[], marginDegrees: number = 2): [number, number] => {
  const min = Math.min(...values);
  const max = Math.max(...values);
  
  return [
    min - marginDegrees,
    max + marginDegrees
  ];
};

// 睡眠ステージの値フォーマッター
export const formatSleepStage = (value: number): string => {
  switch (value) {
    case 0: return 'Deep';
    case 1: return 'Light';
    case 2: return 'REM';
    case 3: return 'Wake';
    default: return '不明';
  }
};

// 姿勢の値フォーマッター
export const formatPosture = (value: number): string => {
  switch (value) {
    case 0: return '仰向け';
    case 1: return '横向き';
    case 2: return 'うつ伏せ';
    default: return '不明';
  }
};

// 姿勢データを数値に変換
export const convertPostureToNumber = (posture: string): number => {
  switch (posture) {
    case 'supine': return 0;     // 仰向け
    case 'sideways': return 1;   // 横向き
    case 'prone': return 2;      // うつ伏せ
    default: return -1;
  }
};

// 20分間隔でティックを表示するためのフィルター
export const getXAxisTicks = <T extends { time: string }>(data: T[]) => {
  return data.filter((_, index) => index % 10 === 0).map(item => item.time);
};
